export default function() {
  return {
    vehicle_movements: {
      origin_destinies: [
        "Oficina",
        "Taller",
        "VTV",
        "Verificación Policial",
        "Lavadero",
        "Estacionamiento – Circulo Militar",
        "Estacionamiento – Circulo Trovador",
        "Otros"
      ],
      reasons: [
        "Lavado",
        "VTV",
        "Verificación Policial",
        "Service / Reparación",
        "Prueba vehículo",
        "Uso interno",
        "Préstamo a terceros",
        "Grabado",
        "Concesionario"
      ]
    }
  };
}
